module.exports = __webpack_public_path__ + "static/media/fa-regular-400.47ffb280.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-regular-400.woff
// module id = 738
// module chunks = 0